/*
* @requires  middleware-websocket.js
* @requires  middleware-ie.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    /**
     * 中间件组件构造函数
     * @param param
     * {
     *     rememberCert: true|false, 是否记住证书的选择，如果记住，则在Session内记住证书的选择，后续不需再选择。可选参数，默认false。
     *     keepTime: "long"|"session"
     *     success：function(m){}, 构造完成回调，m为中间件对象
     *     fail:function(e){}  失败
     * }
     * @constructor
     */
    function Middleware(param) {
        //根据当前浏览器环境，自动判断采用哪种实现。目前仅支持websocket
        this.rememberCert = param.rememberCert | false;
        this.keepTime = param.keepTime | "session";
        this.imp=new $m.MiddlewareWebsocket(param,this,this._eventHandler);
        this.certSnSelected ={
            signCert: null,
            cert: null,
            cryptCert: null,
        };
        this.eventBus={};
    }


    /**
     * 清除记住的证书
     * @private
     */
    Middleware.prototype._cleanRememberCert=function(){
        this.certSnSelected ={
            signCert: null,
            cert: null,
            cryptCert: null,
        };
        $m.util.removeLocal("_HEBCA_CERT_SN_SELECTED.SIGN_CERT");
        $m.util.removeLocal("_HEBCA_CERT_SN_SELECTED.CRYPT_CERT");
        $m.util.removeLocal("_HEBCA_CERT_SN_SELECTED.CERT");
    };

    //获取记住的证书
    Middleware.prototype._getRememberCert=function(param,type,next){
        //如果参数中有sn，则以参数为主
        if(param.sn){
            next();
        }
        else{
            //如果记住了证书
            if(this.rememberCert){

                //查找记住的证书
                if(type==="sign"){
                    if(this.certSnSelected.signCert){
                        param.sn=this.certSnSelected.signCert;
                    }
                    else{
                        //缓存
                        var certSn=$m.util.getLocal("_HEBCA_CERT_SN_SELECTED.SIGN_CERT");
                        if(certSn){
                            param.sn=certSn;
                        }
                    }
                }
                else if(type==="crypt"){
                    if(this.certSnSelected.cryptCert){
                        param.sn=this.certSnSelected.cryptCert;
                    }
                    else{
                        //缓存
                        var certSn=$m.util.getLocal("_HEBCA_CERT_SN_SELECTED.CRYPT_CERT");
                        if(certSn){
                            param.sn=certSn;
                        }
                    }
                }
                else {
                    if(this.certSnSelected.cert){
                        param.sn=this.certSnSelected.cert;
                    }
                    else{
                        //cookie缓存
                        var certSn=$m.util.getLocal("_HEBCA_CERT_SN_SELECTED.CERT");
                        if(certSn){
                            param.sn=certSn;
                        }
                    }
                }

                if(param.sn){
                    //已找到
                    //必须确认证书存在可用
                    var that=this;
                    that.imp.getCertInfo({
                        sn: param.sn,
                        success:function (info){
                            //可用,使用这个证书
                            next()
                        },
                        fail:function (e){
                            //不可用，不用这个记住的证书选择
                            param.sn=null
                            //并且还要清除这个记忆
                            that._cleanRememberCert()
                            next()
                        }
                    })

                }else{
                    //未找到
                    next();
                }

            }else {
                //未开启记忆功能，直接返回
                next();
            }
        }
    };

    /**
     * 尝试依次获取记住的证书
     * @param param
     * @private
     */
    Middleware.prototype._getAllRememberCert=function(param,next){
        var that=this;
        that._getRememberCert(param,"sign",function (){
            if(!param.sn){
                that._getRememberCert(param,"crypt",function (){
                    if(!param.sn){
                        that._getRememberCert(param,"all",function (){
                            next();
                        });
                    }else{
                        next();
                    }
                });
            }else{
                next();
            }
        });
    };

    //设置记住的证书
    Middleware.prototype._setRememberCert=function(cert,type){
        if(this.rememberCert){
            if(type==="sign"){
                this.certSnSelected.signCert=cert.sn;
                $m.util.setLocal("_HEBCA_CERT_SN_SELECTED.SIGN_CERT",cert.sn,this.keepTime);   //仅session内有效
            }
            else if(type==="crypt"){
                this.certSnSelected.cryptCert=cert.sn;
                $m.util.setLocal("_HEBCA_CERT_SN_SELECTED.CRYPT_CERT",cert.sn,this.keepTime);   //仅session内有效
            }else{
                this.certSnSelected.cert=cert.sn;
                $m.util.setLocal("_HEBCA_CERT_SN_SELECTED.CERT",cert.sn,this.keepTime);   //仅session内有效
            }
        }
    };

    /**
     * 保证已经选择了证书
     * @param param
     * @param next
     * @private
     */
    Middleware.prototype._assertSelectCert=function (param,next){
        var that=this;
        if(param.sn){
            //指定SN，不用选择
            next();
        }else {
            //未指定，尝试获取已记住的证书
            that._getAllRememberCert(param,function (){
                if(!param.sn){
                    //重新选择
                    that.selectCert({
                        success:function (cert) {
                            param.sn=cert.sn;
                            next();
                        },
                        fail:function (e) {
                            $m.util.fail(param,e);
                        }
                    })
                }else{
                    //获取到记住的证书
                    next();
                }
            });
        }
    }

    Middleware.prototype._assertSelectSignCert=function (param,next){
        var that=this;
        //尝试获取已记住的证书
        this._getRememberCert(param,"sign",function (){
            if(!param.sn){
                that.selectCert({
                    certType:"sign",
                    success:function (cert) {
                        param.sn=cert.sn;
                        next();
                    },
                    fail:function (e) {
                        $m.util.fail(param,e);
                    }
                })
            }
            else{
                next();
            }
        });
    }

    Middleware.prototype._assertSelectCryptCert=function (param,next){
        var that=this;
        //尝试获取已记住的证书
        this._getRememberCert(param,"crypt",function (){
            if(!param.sn){
                that.selectCert({
                    certType:"crypt",
                    success:function (cert) {
                        param.sn=cert.sn;
                        next();
                    },
                    fail:function (e) {
                        $m.util.fail(param,e);
                    }
                })
            }
            else{
                next();
            }
        });
    }

    Middleware.prototype._assertCertLogined=function (param,next){
        var that=this;
        this._getAllRememberCert(param,function (){
            var seq=new $m.Seq();
            seq.then(function (){
                if(!param.sn) {
                    //选择证书
                    that.selectCert({
                        certType: "sign",
                        success:function (cert) {
                            param.sn=cert.sn;
                            seq.resolve(cert);
                        },
                        fail:function (e) {
                            seq.reject(e);
                        }
                    });
                }else{
                    that.getCertInfo({
                        sn: param.sn,
                        success:function (cert){
                            seq.resolve(cert)
                        },
                        fail:function (e) {
                            seq.reject(e);
                        }
                    })
                }
            }).then(function (seq,cert){
                //检查登录
                //如果已登录，或者设置了密码，则不用登录
                if(cert.isAppLogined || (param.password && param.password!=="") ){
                    seq.resolve();
                }
                else {
                    //需要等录
                    that.login({
                        sn: param.sn,
                        success:function () {
                            seq.resolve();
                        },
                        fail: function (e) {
                            seq.reject(e);
                        }
                    });
                }
            }).then(function () {
                next()
            }).onerror(function (e) {
                $m.util.fail(param,e);
            }).run();
        });
    }

    Middleware.prototype._assertSignCertLogined=function (param,next){
        var that=this;
        this._getRememberCert(param,"sign",function (){
            var seq=new $m.Seq();
            seq.then(function (){
                if(!param.sn) {
                    //选择证书
                    that.selectCert({
                        certType: "sign",
                        success:function (cert) {
                            param.sn=cert.sn;
                            seq.resolve(cert);
                        },
                        fail:function (e) {
                            seq.reject(e);
                        }
                    });
                }else{
                    that.getCertInfo({
                        sn: param.sn,
                        success:function (cert){
                            seq.resolve(cert)
                        },
                        fail:function (e) {
                            seq.reject(e);
                        }
                    })
                }
            }).then(function (seq,cert){
                //检查登录
                //如果已登录，或者设置了密码，则不用登录
                if(cert.isAppLogined || (param.password && param.password!=="") ){
                    seq.resolve();
                }
                else {
                    //需要等录
                    that.login({
                        sn: param.sn,
                        success:function () {
                            seq.resolve();
                        },
                        fail: function (e) {
                            seq.reject(e);
                        }
                    });
                }
            }).then(function () {
                next()
            }).onerror(function (e) {
                $m.util.fail(param,e);
            }).run();
        });
    }

    Middleware.prototype._assertCryptCertLogined=function (param,next){
        var that=this;
        this._getRememberCert(param,"crypt",function (){
            var seq=new $m.Seq();
            seq.then(function (){
                if(!param.sn) {
                    //选择证书
                    that.selectCert({
                        certType: "crypt",
                        success:function (cert) {
                            param.sn=cert.sn;
                            seq.resolve(cert);
                        },
                        fail:function (e) {
                            seq.reject(e);
                        }
                    });
                }else{
                    that.getCertInfo({
                        sn: param.sn,
                        success:function (cert){
                            seq.resolve(cert)
                        },
                        fail:function (e) {
                            seq.reject(e);
                        }
                    })
                }
            }).then(function (seq,cert){
                //检查登录
                //如果已登录，或者设置了密码，则不用登录
                if(cert.isAppLogined || (param.password && param.password!=="") ){
                    seq.resolve();
                }
                else {
                    //需要等录
                    that.login({
                        sn: param.sn,
                        success:function () {
                            seq.resolve();
                        },
                        fail: function (e) {
                            seq.reject(e);
                        }
                    });
                }
            }).then(function () {
                next()
            }).onerror(function (e) {
                $m.util.fail(param,e);
            }).run();
        });
    }

    Middleware.prototype._addCertToArray=function(certs,cert){
        for(var i=0;i<certs.length;i++){
            if(certs[i].sn===cert.sn){
                return ;
            }
        }

        certs.push(cert);
    };

    Middleware.prototype._removeCert=function(certs,cert){
        for(var i=0;i<certs.length;i++){
            if(certs[i].sn===cert.sn){
                certs.splice(i,1)
            }
        }
    };

    Middleware.prototype._fiterCerts=function(certs,filter,excludeFilter){
        if(certs.length===0)
            return certs;

        var filterCerts=[];
        var that=this;
        if(filter && (filter.issuer || filter.deviceName || filter.sn )){
            if(filter.issuer){
                certs.forEach(function (v) {
                    for(var i=0;i<filter.issuer.length;i++){
                        if(filter.issuer[i]===v.issuer.cn){
                            that._addCertToArray(filterCerts,v);
                        }
                    }
                });
            }

            if(filter.deviceName){
                certs.forEach(function (v) {
                    for(var i=0;i<filter.deviceName.length;i++){
                        if(filter.deviceName[i]===v.deviceName){
                            that._addCertToArray(filterCerts,v);
                        }
                    }
                });
            }

            if(filter.sn){
                certs.forEach(function (v) {
                    for(var i=0;i<filter.sn.length;i++){
                        if(filter.sn[i]===v.sn){
                            that._addCertToArray(filterCerts,v);
                        }
                    }
                });
            }
        }
        else
        {
            filterCerts=certs;
        }

        if(excludeFilter){
            if(excludeFilter.issuer){
                var todelete=[];
                filterCerts.forEach(function (v,index) {
                    for(var i=0;i<excludeFilter.issuer.length;i++){
                        if(excludeFilter.issuer[i]===v.issuer.cn){
                            todelete.push(v);
                        }
                    }
                });
                for(var i=0;i<todelete.length;i++){
                    that._removeCert(filterCerts,todelete[i])
                }

            }

            if(excludeFilter.deviceName){
                var todelete=[];
                filterCerts.forEach(function (v,index) {
                    for(var i=0;i<excludeFilter.deviceName.length;i++){
                        if(excludeFilter.deviceName[i]===v.deviceName){
                            todelete.push(v);
                        }
                    }
                });
                for(var i=0;i<todelete.length;i++){
                    that._removeCert(filterCerts,todelete[i])
                }
            }

            if(excludeFilter.sn){
                var todelete=[];
                filterCerts.forEach(function (v,index) {
                    for(var i=0;i<excludeFilter.sn.length;i++){
                        if(excludeFilter.sn[i]===v.sn){
                            todelete.push(v);
                        }
                    }
                });
                for(var i=0;i<todelete.length;i++){
                    that._removeCert(filterCerts,todelete[i])
                }
            }
        }

        return filterCerts;
    };

    /**
     * 设置记住证书的选择
     * @param rememberCert
     * @param keepTime
     */
    Middleware.prototype.setRememberCert=function (rememberCert,keepTime){
        this.rememberCert = rememberCert | false;
        this.keepTime = keepTime | "session";
    };

    /**
     * 重新加载。
     * 该函数将清空所有内部状态。
     * @param param
     * {
     *     success：function(){},
     *     fail:function(e){}
     * }
     */
    Middleware.prototype.reload=function(param){
        this.imp.reload(param);
        this._cleanRememberCert();
    };

    /**
     * 清空状态。包括：选中的证书，登出所有设备。
     * @param param
     * {
     *     success：function(){},
     *     fail:function(e){}
     * }
     */
    Middleware.prototype.reset=function(param){
        this._cleanRememberCert();
        this.logout(param);  //登出所有设备
    };

    /**
     * 获取证书列表
     * @param param
     * {
     *     certType: string, sign|crypt|all. 可选参数，默认sign
     *     subjectOids: array, 可选参数，可附加获取主题项oid
     *     extOids：array, 可选参数，可附加获取扩展项
     *     success: function(certs){}
     *              其中certs为证书列表对象，数组类型，数组中包含的对象定义如下：
     *              {
     *                 sn：序列号
     *                 subject：主题对象，包含属性： cn、g、o、ou
     *                 issuer：签发者对象
     *                 notBefore：有效期起始
     *                 notAfter：有效期截止
     *                 alg：算法
     *                 certType：类型
     *                 cert: 证书Base64字符串
     *                 deviceId： 证书所在的设备ID
     *                 isAppLogined: 所在的设备是否已登录
     *                 deviceName: 设备名称
     *                 path: 路径
     *                 subjectOids: array of { oid:xxx , value: xxx }
     *                 extOids: array of { oid:xxx , value: xxx }: 扩展项，根据extOids。
     *              }
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.getCerts=function (param) {
        this.imp.getCerts(param);
    };

    /**
     * 获取证书信息
     * @param param
     * {
     *     sn: 证书序列号,可选，如果缺省则选择证书
     *     cert: 证书字符串
     *     subjectOids: array, 可选参数，可附加获取主题项oid
     *     extOids：array, 可选参数，可附加获取扩展项
     *     success: function(cert){}
     *              建getCerts返回结果
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.getCertInfo=function(param){
        var that=this;
        if(param.cert){
            that.imp.getCertInfo(param)
        }else{
            this._assertSelectCert(param,function (){
                that.imp.getCertInfo(param);
            })
        }
    };

    /**
     * 选择证书
     * @param param
     * {
     *     certType: string, sign}crypt|all. 可选参数，默认sign
     *     filter：过滤对象
     *          {
     *              issuer： 签发者CN过滤，数组，可填写多个
     *              deviceName：数组，可填写多个
     *              sn： 数组，可填写多个
     *          }
     *     excludeFilter：排除过滤对象，
     *          {
     *              issuer： 签发者CN过滤，数组，可填写多个
     *              deviceName： 数组，可填写多个
     *              sn： 数组，可填写多个
     *          }
     *     success: function(cert){}
     *              选中的证书，对象定义如下：
     *              {
     *                 sn：序列号
     *                 subject：主题对象，包含属性： cn、g、o、ou
     *                 issuer：签发者对象
     *                 notBefore：有效期起始
     *                 notAfter：有效期截止
     *                 alg：算法
     *                 type：类型
     *                 cert: 证书Base64字符串
     *                 deviceId： 证书所在的设备ID
     *                 isAppLogined: 所在的设备是否已登录
     *                 deviceName：设备名称
     *                 path：路径
     *              }
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.selectCert=function (param) {
        var that=this;
        this._getRememberCert(param,param.certType,function (){
            if(param.sn)
            {
                //已经记住证书，则不再选择
                that.imp.getCertInfo(param);
                return;
            }

            if($m._ui && $m._ui.selectCert){
                var seq=new $m.Seq();
                seq.then(function () {
                    //获取证书列表
                    that.getCerts({
                        certType: (param && param.certType)? param.certType: undefined,
                        success:function (certs) {
                            seq.resolve(certs);
                        },
                        fail: function (e) {
                            seq.reject(e);
                        }
                    })
                })
                    .then(function (seq,certs) {
                        //过滤
                        certs=that._fiterCerts(certs,param.filter,param.excludeFilter);
                        seq.resolve(certs);
                    })
                    .then(function (seq,certs) {
                        //选择
                        if(certs.length===0){
                            seq.reject(new Error("没有找到证书"));
                        }
                        else if(certs.length===1){
                            seq.resolve(certs[0]);
                        }
                        else{
                            $m._ui.selectCert({
                                certs: certs,
                                success: function (cert) {
                                    seq.resolve(cert);
                                },
                                fail:function (e) {
                                    seq.reject(e);
                                }
                            })
                        }
                    })
                    .then(function (seq,cert) {
                        //选择完成
                        that._setRememberCert(cert,param.certType?param.certType:"sign");   //记住证书
                        $m.util.success(param,cert);
                    })
                    .onerror(function (e) {
                        $m.util.fail(param,e);
                    })
                    .run();
            }
            else{
                //未开启UI界面，使用原生界面，选中后，需要记住
                var success=param.success;
                param.success=function (cert) {
                    that._setRememberCert(cert,param.certType?param.certType:"sign");   //记住证书
                    success(cert);
                };
                that.imp.selectCert(param);
            }
        });
    };



    /**
     * 签名
     * @param param
     * {
     *     sn: 签名证书序列号
     *     data: 原文
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     password: 登录密码，可选
     *     success: function(sign){}
     *              sign为签名结果对象，包括：
     *              {
     *                  cert: 签名证书字符串
     *                  signature： 签名结果
     *              }
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.sign=function (param) {
        var that=this
        this._assertSignCertLogined(param,function (){
            that.imp.sign(param)
        })
    };

    Middleware.prototype.signBatch=function (param) {
        var that=this
        this._assertSignCertLogined(param,function (){
            that.imp.signBatch(param)
        })
    };

    /**
     * 登录证书
     * @param param
     * {
     *     sn: 证书序列号，可选，如果缺省，则自动选择证书。
     *     password：密码，可选
     *     success: function(){}
     *     fail: function(e){}
     *          e错误对象，除了包含错误消息外，还包含：
     *          {
     *              retryTimes： 重试次数
     *          }
     * }
     * @constructor
     */
    Middleware.prototype.login=function(param){
        var that=this;
        this._getAllRememberCert(param,function (){
            if($m._ui && $m._ui.loginCert && (!param.password || param.password==="") ){
                //如果设置了密码，则不需要界面
                var seq=new $m.Seq();
                seq.then(function () {
                    //选择证书
                    if(param.sn){
                        //读取证书信息
                        that.imp.getCertInfo({
                            sn: param.sn,
                            success:function (cert) {
                                seq.resolve(cert);
                            },
                            fail:function (e) {
                                seq.reject(e);
                            }
                        });
                    }
                    else{
                        that.selectCert({
                            success: function (cert) {
                                param.sn=cert.sn;
                                seq.resolve(cert);
                            },
                            fail:function (e) {
                                seq.reject(e);
                            }
                        })
                    }
                })
                    .then(function (seq,cert) {
                        //判断是否需要登录
                        if(cert.isAppLogined){
                            //已登录,不需要再登
                            seq.resolve({
                                logined: true,
                            });
                        }
                        else{
                            $m._ui.loginCert({
                                cert: cert,
                                success:function (password) {
                                    seq.resolve({
                                        logined:false,
                                        password: password
                                    });
                                },
                                fail:function (e) {
                                    seq.reject(e);
                                }
                            })
                        }
                    })
                    .then(function (seq,ret) {
                        if(!ret.logined){
                            param.password=ret.password;
                            that.imp.login(param);
                        } else {
                            $m.util.success(param);
                        }
                    })
                    .onerror(function (e){
                        $m.util.fail(param,e);
                    })
                    .run();
            }
            else{
                that.imp.login(param);
            }
        });
    };

    /**
     * 登出
     * @param param
     * {
     *     sn: 证书序列号，可选，如果缺省，则登出所有证书
     *     success: function(){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.logout=function(param){
        this.imp.logout(param);
    };

    /**
     * 验证电子签名
     * @param param
     * {
     *     cert: 签名证书
     *     data: 原文
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     signature: 签名结果
     *     success: function(){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.verifySign=function(param){
        this.imp.verifySign(param);
    };

    Middleware.prototype.verifySignBatch=function(param){
        this.imp.verifySignBatch(param);
    };

    /**
     * 证书加密
     * @param param
     * {
     *     cert: 加密证书
     *     data: 原文
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     success: function(encryptData){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.certEncrypt=function(param){
        this.imp.certEncrypt(param);
    };

    /**
     * 证书解密
     * @param param
     * {
     *     sn: 解密证书序列号，可选，如果为空，则自动选择
     *     encryptData：密文
     *     dataFormat：明文格式，Base64、Text，可选参数，默认Text
     *     charset: 当明文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     password:密码
     *     success: function(data){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.certDecrypt=function(param){
        var that=this
        this._assertCryptCertLogined(param,function (){
            that.imp.certDecrypt(param)
        })
    };

    /**
     * 生成密钥，并加密导出
     * @param param
     * {
     *     alg：对称算法
     *     sn: 证书所在的容器
     *     certs: array 加密证书，可以多个
     *     success: function(keys){}
     *              keys：
     *              {
     *                  keyId: key唯一标识
     *                  wrapperKeys: array 加密后的对称密钥，顺序同传入的加密证书顺序
     *              }
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.genAndWrapperKey=function(param){
        var that=this
        this._assertSelectCryptCert(param,function (){
            that.imp.genAndWrapperKey(param)
        })
    };

    Middleware.prototype.genKey=function(param){
        var that=this
        this._assertSelectCryptCert(param,function (){
            that.imp.genKey(param)
        })
    };

    /**
     * 导入加密的对称密钥
     * @param param
     * {
     *     sn: 证书序列号
     *     wrapperKey: 对称密钥密文
     *     alg: 算法
     *     success: function(keyId){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.importWrapperKey=function(param){
        var that=this
        this._assertCryptCertLogined(param,function (){
            that.imp.importWrapperKey(param)
        })
    };

    Middleware.prototype.setSymmKey=function(param){
        var that=this
        this._assertCryptCertLogined(param,function (){
            that.imp.setSymmKey(param)
        })
    };

    /**
     * 对称加密
     * @param param
     * {
     *      keyId： key唯一标识
     *      data: 待加密原文
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     iv: 加密iv的Base64,默认为空，可选
     *     padding: 填充, no|pkcs5，默认no，可选
     *     success: function(encryptData){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.encrypt=function(param){
        this.imp.encrypt(param);
    };

    Middleware.prototype.encryptStep=function(param){
        this.imp.encryptStep(param);
    };

    /**
     * 对称解密
     * @param param
     * {
     *      keyId： key唯一标识
     *      encryptData: 密文
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     iv: 加密iv的Base64,默认为空，可选
     *     padding: 填充, no|pkcs5，默认no，可选
     *     success: function(data){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.decrypt=function(param){
        this.imp.decrypt(param);
    };
    Middleware.prototype.decryptStep=function(param){
        this.imp.decrypt(param);
    };

    /**
     * 对称加密
     * @param param
     * {
     *      keyId： key唯一标识
     *      file: 明文文件路径
     *      encryptFile：加密文件路径，可选，如果为空，则使用临时文件
     *     iv: 加密iv的Base64,默认为空，可选
     *     padding: 填充, no|pkcs5，默认no，可选
     *     progress: function(currentStep,allStep,cancel){} 进度显示和控制，可选
     *     success: function(encryptFile){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.encryptFile=function(param){
        this.imp.encryptFile(param);
    };

    /**
     * 对称解密
     * @param param
     * {
     *      keyId： key唯一标识
     *      file: 明文文件路径，可选，如果为空，则使用临时文件
     *      encryptFile：加密文件路径
     *     iv: 加密iv的Base64,默认为空，可选
     *     padding: 填充, no|pkcs5，默认no，可选
     *     progress: function(currentStep,allStep,cancel){} 进度显示和控制，可选
     *     success: function(file){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.decryptFile=function(param){
        this.imp.decryptFile(param);
    };


    /**
     * 关闭密钥
     * @param param
     * {
     *     keyId： key唯一标识
     *     success: function(){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.closeKey=function(param){
        this.imp.closeKey(param);
    };

    /**
     * 获取设备列表
     * @param param
     * {
     *     success: function(devices){}
     *              devices为设备列表，为数组，其中包含对象：
     *              {
     *                  deviceId：设备ID,
     *                  deviceName: 设备名称
     *              }
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.getDevices=function (param) {
        this.imp.getDevices(param);
    };

    /**
     * 选择设备
     * @param param
     * {
     *     filter: array 过滤设备，可选
     *     excludeFilter：array 排查过滤，可选
     *     success：function(device){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.selectDevice=function(param){
        if($m._ui && $m._ui.selectDevice){
            var seq=new $m.Seq();
            var that=this;
            seq.then(function () {
                //获取设备列表
                that.getDevices({
                    success:function (devices) {
                        seq.resolve(devices);
                    },
                    fail:function (e) {
                        seq.reject(e);
                    }
                });
            }).then(function (seq,devices) {
                //过滤选择证书
                devices=that._filterDevice(devices,param);
                if(devices.length===0){
                    seq.reject(new Error("没有找到设备"));
                }
                else if(devices.length===1){
                    seq.resolve(devices[0]);
                }
                else{
                    $m._ui.selectDevice({
                        devices: devices,
                        success:function (device) {
                            seq.resolve(device);
                        },
                        fail:function (e) {
                            seq.reject(e);
                        }
                    });
                }
            }).then(function (seq,device) {
                $m.util.success(param,device);
            }).onerror(function (e) {
                $m.util.fail(param,e);
            }).run();
        }
        else{
            this.imp.selectDevice(param);
        }
    };

    Middleware.prototype._addDeviceToArray=function(devices,device){
        for(var i=0;i<devices.length;i++){
            if(devices[i].deviceId===device.deviceId){
                return ;
            }
        }

        devices.push(device);
    };

    Middleware.prototype._removeDevice=function(devices,device){
        for(var i=0;i<devices.length;i++){
            if(devices[i].deviceId===device.deviceId){
                devices.splice(i,1)
            }
        }
    };

    Middleware.prototype._filterDevice=function(devices,param){
        if(devices.length===0)
            return devices;

        var filterDevices=[];
        var that=this;
        if(param.filter){
            devices.forEach(function (v) {
                for(var i=0;i<param.filter.length;i++){
                    if(param.filter[i]===v.deviceName){
                        that._addDeviceToArray(filterDevices,v);
                    }
                }
            });
        }
        else
        {
            filterDevices=devices;
        }

        if(param.excludeFilter){
            var todelete=[];
            filterDevices.forEach(function (v,index) {
                for(var i=0;i<param.excludeFilter.length;i++){
                    if(param.excludeFilter[i]===v.deviceName){
                        todelete.push(v);
                    }
                }
            });
            for(var i=0;i<todelete.length;i++){
                that._removeDevice(filterDevices,todelete[i])
            }

        }

        return filterDevices;
    };

    Middleware.prototype._assertSelectDevice=function (param,next){
        var that=this;
        if(!param.deviceId){
            this.selectDevice({
                success:function (device) {
                    param.deviceId=device.deviceId;
                    next();
                },
                fail:function (e) {
                    $m.util.fail(param,e);
                }
            });
        }
        else{
            next();
        }
    }

    Middleware.prototype._assertDeviceLogined=function (param,next){
        var that=this;
        this.loginDevice({
            deviceId: param.deviceId,
            password: param.password,
            success:function (deviceId) {
                if(!param.deviceId)
                    param.deviceId=deviceId
                next();
            },
            fail:function (e) {
                $m.util.fail(param,e);
            }
        })
    }

    /**
     * 获取设备信息
     * @param param
     * {
     *     deviceId：设备ID，可选，如果缺省则选择设备
     *     success：function(deviceInfo){}
     *              deviceInfo
     *              {
     *                  version: 版本
	 *                  manufacturer string
	 *                  issuer string
	 *                  label string
	 *                  serialNumber string
     *                  hwversion DeviceVersion
     *                  firmwareVersion DeviceVersion
     *                  algSymCap uint64
     *                  algAsymCap uint64
     *                  algHashCap uint64
     *                  devAuthAlgId uint64
     *                  totalSpace uint64
     *                  freeSpace uint64
     *                  apps：array
     *                  containers：array
     *              }
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.getDeviceInfo=function(param){
        var that=this;
        this._assertSelectDevice(param,function (){
            that.imp.getDeviceInfo(param);
        });
    };

    /**
     * 获取随机数
     * @param param
     * {
     *     deviceId：设备ID，可选，如果缺省则选择设备
     *     randomLength： 随机数长度
     *     success：function(random){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.getRandom=function(param){
        var that=this;
        this._assertSelectDevice(param,function (){
            that.imp.getRandom(param);
        });
    };


    /**
     * 获取证书应用中的数据列表
     * @param param
     * {
     *     sn: 证书序列号，可选，如果为空，则获取所有设备的数据
     *     path：数据路径，可选，
     *     success: function(datas){}
     *              datas为数据列表，为数组，其中包含对象：
     *              {
     *                  name：数据名称
     *                  path：数据路径
     *              }
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.getDatas=function (param) {
        this.imp.getDatas(param);
    };

    /**
     * 读取数据
     * @param param
     * {
     *      sn: 证书序列号，可选
     *      name: 数据名称，
     *      path：数据路径，可选，
     *      dataFormat：返回的数据编码，text、base64，可选参数，默认text
     *      charset: 当返回格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *      success: function(data){}
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.readData=function (param) {
        if(param.path){
            this.imp.readData(param);
        }
        else{
            var that=this
            this._assertSelectCert(param,function (){
                that.imp.readData(param);
            })
        }
    };

    /**
     * 写入数据
     * @param param
     * {
     *      sn: 证书序列号，可选
     *      name: 数据名称，
     *      path：数据路径，可选，path和sn要二选一。
     *      dataFormat：数据编码，text、base64，可选参数，默认text
     *      charset: 当格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *      data: 数据
     *      isReadNeedLogin: 读取数据是否需要登录
     *      success: function(){}
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.writeData=function (param) {
        if(param.path){
            this.imp.writeData(param);
        }
        else{
            var that=this
            this._assertCertLogined(param,function (){
                that.imp.writeData(param);
            })
        }
    };

    /**
     * 删除数据
     * @param param
     * {
     *      sn: 证书序列号，可选
     *      name: 数据名称，
     *      path：数据路径，可选，path和sn要二选一。
     *      success: function(){}
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.deleteData=function (param) {
        if(param.path){
            this.imp.deleteData(param);
        }
        else{
            var that=this
            this._assertSignCertLogined(param,function (){
                that.imp.deleteData(param);
            })
        }
    };

    /**
     * 摘要
     * @param param
     * {
     *     alg： 摘要算法
     *     data: 待加密原文
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     success: function(digest){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.digest=function(param){
        this.imp.digest(param);
    };

    /**
     * 文件摘要
     * @param param
     * {
     *      alg： 摘要算法
     *      file: 文件路径
     *      progress: function(currentStep,allStep,next,cancel){} 进度显示和控制，可选
     *     success: function(digest){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.digestFile=function(param){
        this.imp.digestFile(param);
    };

    /**
     * 软件加密算法
     * @param param
     * {
     *      key： 密钥B64
     *      alg： 算法
     *      data: 待加密原文
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     iv: 加密iv的Base64,默认为空，可选
     *     padding: 填充, no|pkcs5，默认no，可选
     *     success: function(encryptData){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.encryptSoft=function(param){
        this.imp.encryptSoft(param);
    };

    /**
     * 软件加密算法
     * @param param
     * {
     *      key： 密钥B64
     *      alg： 算法
     *      file： 明文文件
     *      encryptFile: 密文文件
     *     iv: 加密iv的Base64,默认为空，可选
     *     padding: 填充, no|pkcs5，默认no，可选
     *     progress: function(currentStep,allStep,cancel){} 进度显示和控制，可选
     *     success: function(encryptFile){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.encryptSoftFile=function(param){
        this.imp.encryptSoftFile(param);
    };

    /**
     * 软件解密算法
     * @param param
     * {
     *      key： 密钥B64
     *      alg： 算法
     *      encryptData: 加密原文
     *     iv: 加密iv的Base64,默认为空，可选
     *     padding: 填充, no|pkcs5，默认no，可选
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     success: function(Data){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.decryptSoft=function(param){
        this.imp.decryptSoft(param);
    };

    /**
     * 软件解密算法
     * @param param
     * {
     *      key： 密钥B64
     *      alg： 算法
     *      file： 明文文件
     *      encryptFile: 密文文件
     *     iv: 加密iv的Base64,默认为空，可选
     *     padding: 填充, no|pkcs5，默认no，可选
     *     progress: function(currentStep,allStep,cancel){} 进度显示和控制，可选
     *     success: function(file){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.decryptSoftFile=function(param){
        this.imp.decryptSoftFile(param);
    };

    /**
     * PKCS7消息签名
     * @param param
     * {
     *     sn: 签名证书序列号
     *     data: 原文
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     password: 登录密码，可选
     *     detachData：是否不附加原文，可选
     *     withTimeStamp: 是否添加时间戳，可选
     *     timeStamp: 时间戳，可选
     *     success: function(message){}
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.signMessage=function (param) {
        var that=this;
        this._assertSignCertLogined(param,function (){
            that.imp.signMessage(param);
        })
    };

    Middleware.prototype.signMessageBatch=function (param) {
        var that=this;
        this._assertSignCertLogined(param,function (){
            that.imp.signMessageBatch(param);
        })
    };


    /**
     * PKCS7消息验证
     * @param param
     * {
     *     message: 签名消息
     *     data: 原文，可选
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     success: function(){}
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.verifyMessage=function (param) {
        this.imp.verifyMessage(param);
    };

    Middleware.prototype.verifyMessageBatch=function (param) {
        this.imp.verifyMessageBatch(param);
    };

    /**
     * 获取PKCS7信息
     * @param param
     * {
     *     message: 签名消息
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     success: function(info){}
     *              info：
     *                  content: 原文
     *                  signCert：签名证书
     *                  timeStamp：时间戳
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.getMessageInfo=function(param) {
        this.imp.getMessageInfo(param);
    };

    /**
     * PKCS7消息加密
     * @param param
     * {
     *     certs: 接收人的加密证书，数组类型，可以有多个接收人
     *     data: 原文
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     alg：算法
     *     encryptUseDevice: 是否使用Key硬件算法，可选，默认否
     *     sn: 可选，如果使用硬件算法，需要指定加密证书的sn
     *     success: function(message){}
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.envelopeMessage=function (param) {
        this.imp.envelopeMessage(param);
    };

    Middleware.prototype.envelopeMessageFile=function (param) {
        this.imp.envelopeMessageFile(param);
    };

    Middleware.prototype.envelopeMessageBigFile=function (param) {
        this.imp.envelopeMessageBigFile(param);
    };

    /**
     * PKCS7消息解密
     * @param param
     * {
     *     message: 加密消息
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     password: 登录口令
     *     encryptUseDevice：是否使用Key硬件算法，可选，默认否
     *     success: function(data){}
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.unenvelopeMessage=function (param) {
        var that=this;
        this._assertCryptCertLogined(param,function (){
            that.imp.unenvelopeMessage(param);
        })
    };

    Middleware.prototype.unenvelopeMessageFile=function (param) {
        var that=this;
        this._assertCryptCertLogined(param,function (){
            that.imp.unenvelopeMessageFile(param);
        })
    };

    Middleware.prototype.unenvelopeMessageBigFile=function (param) {
        var that=this;
        this._assertCryptCertLogined(param,function (){
            that.imp.unenvelopeMessageBigFile(param);
        })
    };

    /**
     * 登录设备
     * @param param
     * {
     *     deviceId: 设备ID，可选，如果为空，则自动选择
     *     app: 应用名称，可选，默认KOAL_ECC_APP
     *     password： 密码
     *     success: function(deviceId){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.loginDevice=function(param){
        var that=this;
        var seq=new $m.Seq();
        seq.then(function () {
            if(!param.deviceId){
                that.selectDevice({
                    success:function (device) {
                        param.deviceId=device.deviceId;
                        seq.resolve(device);
                    },
                    fail:function (e) {
                        seq.reject(e);
                    }
                })
            }
            else {
                that.getDevices({
                    success:function (devices) {
                        for(var i=0;i<devices.length;i++){
                            if(devices[i].deviceId===param.deviceId){
                                seq.resolve(devices[i]);
                                return
                            }
                        }

                        seq.reject(new Error("没有找到对应的设备"))
                    },
                    fail:function (e) {
                        seq.reject(e);
                    }
                })
            }
        }).then(function (seq,device){
            //判断是否已登录
            that.isDeviceLogined({
                deviceId: device.deviceId,
                success:function (deviceLoginInfo) {
                    seq.resolve({
                        device: device,
                        loginInfo: deviceLoginInfo,
                    });
                },
                fail:function (e) {
                    seq.reject(e)
                }
            })
        }).then(function (seq,device) {
            if(device.loginInfo.isLogined){
                //已登录，退出
                $m.util.success(param,device.device.deviceId);
            }else{
                //未登录
                if( (!param.password || param.password==="") && $m._ui && $m._ui.loginDevice){
                    //UI层输入密码
                    $m._ui.loginDevice({
                        device:device.device,
                        success:function (password) {
                            param.password=password;
                            seq.resolve();
                        },
                        fail:function (e) {
                            seq.reject(e)
                        }
                    })
                }
                else {
                    seq.resolve();
                }
            }
        }).then(function () {
            //执行登录
            var oldSucess=param.success
            param.success=function (){
                oldSucess(param.deviceId)
            }
            that.imp.loginDevice(param);
        }).onerror(function (e) {
            $m.util.fail(param,e);
        }).run();
    };

    /**
     * 设备是否已登录
     * @param param
     * {
     *     deviceId: 设备ID，可选，如果为空，则自动选择
     *     app: 应用名称，可选，默认KOAL_ECC_APP
     *     success: function(loginInfo){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.isDeviceLogined=function(param){
        var that=this;
        this._assertSelectDevice(param,function (){
            that.imp.isDeviceLogined(param);
        })
    }

    /**
     * 登出设备
     * @param param
     * {
     *     deviceId: 设备ID，可选，如果为空，登出所有设备
     *     app: 应用名称，可选，默认登出所有应用
     *     success: function(){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.logoutDevice=function(param){
        this.imp.logoutDevice(param);
    };

    /**
     * 修改密码
     * @param param
     * {
     *      sn: 证书序列号
     *      oldPassword：
     *      newPassword：
     *     success: function(){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.changePassword=function(param){
        var that=this;
        this._assertSelectCert(param,function (){
            that.imp.changePassword(param);
        })
    };

    /**
     * 生成签名密钥对
     * @param param
     * {
     *     deviceId: 设备ID，可选，如果为空，则自动选择
     *     alg: 算法，可选，默认SM2
     *     app: 应用名称，可选，默认KOAL_ECC_APP
     *     container： 容器名称，可选，默认KOAL_ECC
     *     password：密码
     *     success: function(pubkey){}
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.genKeyPair=function (param) {
        var that=this;
        this._assertDeviceLogined(param,function (){
            that.imp.genKeyPair(param);
        })
    };

    /**
     * 导入加密密钥对
     * @param param
     * {
     *     deviceId: 设备ID
     *     encryptKeyPair：加密密钥对
     *     app: 应用名称，可选，默认KOAL_ECC_APP
     *     container： 容器名称，可选，默认KOAL_ECC
     *     password：密码
     *     success: function(){}
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.importKeyPair=function (param) {
        var that=this;
        this._assertDeviceLogined(param,function (){
            that.imp.importKeyPair(param);
        })

    };

    /**
     * 导入证书
     * @param param
     * {
     *     deviceId: 设备ID
     *     cert：证书
     *     isSign: 是否签名证书
     *     app: 应用名称，可选，默认KOAL_ECC_APP
     *     container： 容器名称，可选，默认KOAL_ECC
     *     password：密码
     *     success: function(){}
     *     fail: function(e){}
     * }
     * @constructor
     */
    Middleware.prototype.importCert=function (param) {
        var that=this;
        this._assertDeviceLogined(param,function (){
            that.imp.importCert(param);
        })
    };

    /**
     * 添加事件监听
     * @param param
     * {
     *     name: 事件名称，insertDevice|removeDevice|dataUpdate|user
     *     callback： function(event){} 监听函数
     * }
     */
    Middleware.prototype.addEventListener=function(param){
        if(this.eventBus[param.name]){
            var find=false;
            for(var i=0;i<this.eventBus[param.name].length;i++){
                if(this.eventBus[param.name][i].callback===param.callback){
                    find=true;
                    break;
                }
            }
            if(!find){
                this.eventBus[param.name].push(param);
                return true;
            }
            else {
                return true;
            }
        }
        else{
            this.eventBus[param.name]=[];
            this.eventBus[param.name].push(param);
            return true;
        }
    };

    /**
     * 删除事件监听
     * @param param
     * {
     *     name: 事件名称
     *     callback:
     * }
     */
    Middleware.prototype.removeEventListener=function (param) {
        if(this.eventBus[param.name]) {
            for(var i=0;i<this.eventBus[param.name].length;i++){
                if(this.eventBus[param.name][i].callback===param.callback){
                    this.eventBus[param.name].splice(i,1)
                    return true;
                }
            }

            return false;
        }
        else{
            return false;
        }
    };

    Middleware.prototype._eventHandler=function(eventName,eventObject){
        $m.debug("event:",eventName,eventObject);

        if(this.eventBus[eventName]){
            for(var i=0;i<this.eventBus[eventName].length;i++){
                if(this.eventBus[eventName][i].callback){
                    this.eventBus[eventName][i].callback(eventName,eventObject);
                }
            }
        }
    };

    /**
     * 触发用户自定义事件
     * @param param
     * {
     *     name: 事件子名称
     *     object: 事件信息，可选
     *     deviceId: 设备ID，可选
     *     success: function(){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.fireEvent=function(param){
        this.imp.fireEvent(param);
    };

    /**
     * 发起密钥协商
     * @param param
     * {
     *     sn: 加密证书序列号
     *     alg: 算法
     *     sponsorId: 发起者ID
     *     success: function(sponsorData){}
     *              sponsorData：
     *              {
     *                  cert： 发起者证书
     *                  tempPubkey：临时公钥
     *              }
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.agreementBegin=function(param){
        var that=this;
        this._assertSelectCryptCert(param,function (){
            that.imp.agreementBegin(param);
        })
    };

    /**
     * 响应方密钥协商
     * @param param
     * {
     *     sn: 加密证书序列号
     *     alg：算法
     *     sponsorCert：发起方证书
     *     sponsorTempPubKey：发起方公钥
     *     respondId： 响应方ID
     *     sponsorId： 发起方ID
     *     success: function(responData){}
     *              responData
     *              {
     *                  tempPubkey：响应方临时公钥
     *                  cert: 响应方证书
     *                  keyId: 协商keyId
     *              }
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.agreementResponse=function(param){
        var that=this;
        this._assertSelectCryptCert(param,function (){
            that.imp.agreementResponse(param);
        })
    };

    /**
     * 发起方结束协商
     * @param param
     * {
     *     sn:
     *     respondCert：
     *     respondTempPubKey：
     *     respondId：
     *     success: function(keyId){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.agreementEnd=function(param){
        var that=this;
        this._assertSelectCryptCert(param,function (){
            that.imp.agreementEnd(param);
        })
    };


    /**
     * 读取文件内容
     * @param param
     * {
     *     file: 文件路径
     *     dataFormat:
     *     charset:
     *     success: function(data){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.readFile=function(param){
        this.imp.readFile(param);
    };

    /**
     * 写文件
     * @param param
     * {
     *     file: 文件路径
     *     data：
     *     dataFormat:
     *     charset:
     *     success: function(){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.writeFile=function(param){
        this.imp.writeFile(param);
    };

    /**
     * 下载文件
     * @param param
     * {
     *     url: 文件路径
     *     file：本地保存路径，可选，如果不提供，则使用临时文件
     *     progress: function(currentStep,allStep,cancel){} 进度显示和控制，可选
     *     success: function(file){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.downloadFile=function(param){
        this.imp.downloadFile(param);
    };

    /**
     * 上传文件
     * @param param
     * {
     *     url: 文件路径
     *     file：本地保存路径
     *     partName: 上传的文件part的名称
     *     progress: function(currentStep,allStep,cancel){} 进度显示和控制，可选
     *     success: function(result){}
     *          result: 上传完成后服务器的返回
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.uploadFile=function(param){
        this.imp.uploadFile(param);
    };


    /**
     * 签发时间戳
     * @param param
     * {
     *     data： 原文，可选
     *     dataFormat：原文格式，可选
     *     charset：原文编码，可选
     *     hashB64：摘要B64，可选。hashB64和data二选一
     *     context：时间戳服环境
     *     hashAlg： 摘要算法，可选，如果缺省则采用本地配置
     *     hasCert: 是否包含时间戳证书，可选，默认包含
     *     success: function(timestamp){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.signTimeStamp=function(param){
        this.imp.signTimeStamp(param);
    };

    Middleware.prototype.signTimeStampBatch=function(param){
        this.imp.signTimeStampBatch(param);
    };

    /**
     * 签发时间戳
     * @param param
     * {
     *     data： 原文，可选
     *     dataFormat：原文格式，可选
     *     charset：原文编码，可选
     *     hashB64：摘要B64，可选。hashB64和data二选一
     *     hashAlg： 摘要算法，可选，如果缺省则采用本地配置
     *     timeStamp：时间戳
     *     success: function(){}
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.verifyTimeStamp=function(param){
        this.imp.verifyTimeStamp(param);
    };

    Middleware.prototype.verifyTimeStampBatch=function(param){
        this.imp.verifyTimeStampBatch(param);
    };

    /**
     * 解析时间戳
     * @param param
     * {
     *     timeStamp：时间戳
     *     success: function(info){}
     *          info：
     *              time： 时间
     *              cert： 时间戳证书
     *     fail: function(e){}
     * }
     */
    Middleware.prototype.getTimeStampInfo=function(param){
        this.imp.getTimeStampInfo(param);
    };

    /**
     * 开始认证
     * @param param
     * {
     *     requestId: 请求ID
     *     deviceId：设备ID，格式化时填写
     *     sn：证书SN，解锁时填写
     * }
     */
    Middleware.prototype.authBegin=function (param){
        this.imp.authBegin(param);
    };

    /**
     * 格式化
     * @param param
     * {
     *     authResponse	String	是	认证回应，使用认证密钥加密。中间件校验认证回应成功，进行格式化。
     *     deviceId	String	是	设备ID
     * }
     */
    Middleware.prototype.format=function (param){
        this.imp.format(param);
    };

    /**
     * 解锁
     * @param param
     * {
     *     authResponse	String	是	认证回应，使用认证密钥加密。中间件校验认证回应成功，进行解锁。
     *     sn	String	否	证书SN，如果缺省，则选择
     * }
     */
    Middleware.prototype.unlock=function (param){
        this.imp.unlock(param);
    };

    /**
     * 导入公安对称密钥
     * @param param
     * {
     *     keyIndex	int	是	Key索引 0xA2： 应用维护对称密钥  0xA6：数据加解密对称密钥
     *     key	string	是	对称密钥B64
     *     sn	string	否	证书序列号，如果为空，则先选择证书
     *     password	string	否	登录密码
     * }
     */
    Middleware.prototype.epsImportSymmKey=function (param){
        var that=this;
        this._assertCertLogined(param,function (){
            that.imp.epsImportSymmKey(param);
        })
    };

    /**
     * 写入公安印章数据
     * @param param
     * {
     *     sealData	string	是	公安印章数据B64
     *     sn	string	否	证书序列号，如果为空，则先选择证书
     *     password	string	否	登录密码
     * }
     */
    Middleware.prototype.epsWriteESealData=function (param){
        var that=this;
        this._assertCertLogined(param,function (){
            that.imp.epsWriteESealData(param);
        })
    };

    /**
     * 读取公安印章数据
     * @param param
     * {
     *     keyIndex	Int	是	Key索引，0xA2： 应用维护对称密钥  0xA6：数据加解密对称密钥
     *     alg	string	否	算法，支持SM4-CBC、SM4-ECB，默认SM4-ECB
     *     sn	string	否	证书序列号，如果为空，则先选择证书
     *     password	string	否	登录密码
     * }
     */
    Middleware.prototype.epsReadESealData=function (param){
        var that=this;
        this._assertCertLogined(param,function (){
            that.imp.epsReadESealData(param);
        })
    };

    /**
     * 加密
     * @param param
     * {
     *     keyIndex	Int	是	Key索引，0xA2： 应用维护对称密钥  0xA6：数据加解密对称密钥
     *     alg	string	否	算法，支持SM4-CBC、SM4-ECB，默认SM4-ECB
     *     iv	String	否	初始化向量B64
     *     divCount	Int	否，默认为0	分散次数，设置为0时表示不作分散，设置为非0时通过
     *     ulKeyIndex参数对应的密钥值对分散因子进行分散（分散即使用ulAlgId加密分散因子，得到的结果作为对数据实际加密的密钥值）
     *     divComponent	String	否	分散因子，当divCount设置0时无效
     *     inputData	String	是	输入数据B64
     *     sn	string	否	证书序列号，如果为空，则先选择证书
     *     password	string	否	登录密码
     * }
     */
    Middleware.prototype.epsEncrypt=function (param){
        var that=this;
        this._assertCertLogined(param,function (){
            that.imp.epsEncrypt(param);
        })
    };

    /**
     * 解密
     * @param param
     * {
     *     keyIndex	Int	是	Key索引，0xA2： 应用维护对称密钥  0xA6：数据加解密对称密钥
     *     alg	string	否	算法，支持SM4-CBC、SM4-ECB，默认SM4-ECB
     *     iv	String	否	初始化向量B64
     *     divCount	Int	否，默认为0	分散次数，设置为0时表示不作分散，设置为非0时通过
     *     ulKeyIndex参数对应的密钥值对分散因子进行分散（分散即使用ulAlgId加密分散因子，得到的结果作为对数据实际加密的密钥值）
     *     divComponent	String	否	分散因子，当divCount设置0时无效
     *     inputData	String	是	输入数据B64
     *     sn	string	否	证书序列号，如果为空，则先选择证书
     *     password	string	否	登录密码
     * }
     */
    Middleware.prototype.epsDecrypt=function (param){
        var that=this;
        this._assertCertLogined(param,function (){
            that.imp.epsDecrypt(param);
        })
    };

    /**
     *
     * @param param
     * {
     *     keyIndex	Int	是	Key索引，0xA2： 应用维护对称密钥 0xA6：数据加解密对称密钥
     *     alg	string	否	算法，支持SM4-CBC、SM4-ECB，默认SM4-ECB
     *     iv	String	否	初始化向量B64
     *     divCount	Int	否，默认为0	分散次数，设置为0时表示不作分散，设置为非0时通过
     *     ulKeyIndex参数对应的密钥值对分散因子进行分散（分散即使用ulAlgId加密分散因子，得到的结果作为对数据实际加密的密钥值）
     *     divComponent	String	否	分散因子，当divCount设置0时无效
     *     inputData	String	是	输入数据B64
     *     sn	string	否	证书序列号，如果为空，则先选择证书
     *     password	string	否	登录密码
     * }
     */
    Middleware.prototype.epsMac=function (param){
        var that=this;
        this._assertCertLogined(param,function (){
            that.imp.epsMac(param);
        })
    };

    Middleware.prototype.showFileDialog=function (param){
        this.imp.showFileDialog(param);
    };

    Middleware.prototype.getFileInfo=function (param){
        this.imp.getFileInfo(param);
    };

    Middleware.prototype.getFilePath=function (param){
        this.imp.getFilePath(param);
    };

    Middleware.prototype.removeFile=function (param){
        this.imp.removeFile(param);
    };

    Middleware.prototype.extSign=function (param){
        this.imp.extSign(param);
    };

    Middleware.prototype.extVerify=function (param){
        this.imp.extVerify(param);
    };

    Middleware.prototype.extEncrypt=function (param){
        this.imp.extEncrypt(param);
    };

    Middleware.prototype.extDecrypt=function (param){
        this.imp.extDecrypt(param);
    };

    Middleware.prototype.extGenKeyPair=function (param){
        this.imp.extGenKeyPair(param);
    };

    Middleware.prototype.setContext=function (param){
        this.imp.setContext(param);
    };

    Middleware.prototype.verifyCert=function (param){
        this.imp.verifyCert(param);
    };

    Middleware.prototype.verifyCertAtTime=function (param){
        this.imp.verifyCertAtTime(param);
    };

    Middleware.prototype.verifyCertSign=function (param){
        this.imp.verifyCertSign(param);
    };

    Middleware.prototype.saveEvidence=function (param){
        param.type=param.data.type
        param.data = JSON.stringify(param.data)
        this.imp.saveEvidence(param);
    };

    Middleware.prototype.readEvidence=function (param){
        this.imp.readEvidence(param);
    };

    Middleware.prototype.zxq1Enroll=function (param){
        this.imp.zxq1Enroll(param);
    };

    Middleware.prototype.getPasswordInfo=function (param){
        this.imp.getPasswordInfo(param);
    };

    Middleware.prototype.close=function(){
        this.imp.close()
    };

    $m.Middleware=Middleware;

})(HebcaMiddleware);


